import React, {useEffect, useState} from 'react';
import {FaPlus, FaUser} from 'react-icons/fa';
import {Link} from "react-router-dom";
import {alertaDeErro} from "../services/alertServices";
import {ModalCriarJogador} from "../components/modals/ModalCriarJogador";

export const Jogadores = () => {
    const [jogadores, setJogadores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalAberto, setModalAberto] = useState(false);

    useEffect(() => {
        carregarJogadores();
    }, []);

    const carregarJogadores = async () => {
        try {
            setLoading(true);
            const response = await fetch('/api/Jogadores');
            if (!response.ok) {
                throw new Error('Erro ao carregar jogadores');
            }
            const data = await response.json();
            setJogadores(data);
        } catch (e) {
            console.error(e);
            await alertaDeErro('Erro ao buscar lista de jogadores.');
        } finally {
            setLoading(false);
        }
    };

    const toggleModal = () => {
        setModalAberto(!modalAberto);
    };

    return (
        <div className="container">
            <div className="text-center py-3">
                <h2 className="fw-bold mb-1">Jogadores</h2>
                <p className="text-muted mb-3">
                    Gerencie os atletas cadastrados no sistema.
                </p>

                <button
                    className="btn btn-success rounded-circle shadow float-action-button"
                    onClick={toggleModal}
                    disabled={loading}
                    title="Novo Jogador"
                >
                    <FaPlus size={24}/>
                </button>
            </div>

            {loading ? (
                <p className="text-center">Carregando jogadores...</p>
            ) : (
                <div className="row">
                    {jogadores.length === 0 && (
                        <div className="col-12 text-center">
                            <p className="text-muted">Nenhum jogador cadastrado.</p>
                        </div>
                    )}

                    {jogadores.map(jogador => (
                        <div key={jogador.id} className="col-md-6 col-lg-4 mb-3">
                            <Link
                                to={`/jogador/${jogador.id}`}
                                className="text-decoration-none"
                            >
                                <div className="card shadow-sm h-100 hover-card">
                                    <div className="card-body d-flex align-items-center">
                                        <div className="bg-light rounded-circle p-3 me-3 d-flex align-items-center justify-content-center" style={{width: '60px', height: '60px'}}>
                                            <FaUser size={24} className="text-primary"/>
                                        </div>
                                        <div>
                                            <h5 className="card-title mb-0 text-dark fw-bold">{jogador.nome}</h5>
                                            <small className="text-muted">Ver estatísticas</small>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            )}

            <ModalCriarJogador
                isOpen={modalAberto}
                toggle={toggleModal}
                onJogadorCriado={carregarJogadores}
            />
        </div>
    );
};